import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { EASE } from "./Reveal";

const LINKS = [
  { label: "Collection", href: "#collection" },
  { label: "Process", href: "#process" },
  { label: "Imagine", href: "#imagine" },
  { label: "Why Us", href: "#why-us" },
  { label: "Meet Ella", href: "#ella" },
];

export default function Nav({ onNavigate }) {
  const [open, setOpen] = useState(false);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    onNavigate(href);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50">
      <div className="bg-cream/80 backdrop-blur-md border-b border-terracotta/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-[72px] flex items-center justify-between">
          <a
            href="#top"
            data-testid="nav-logo"
            onClick={(e) => go(e, 0)}
            className="flex items-center gap-2.5"
          >
            <Logo className="h-8 w-8" />
            <span className="font-serif font-semibold text-lg sm:text-xl tracking-tight">
              Ella's Umbrellas
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
                onClick={(e) => go(e, l.href)}
                className="relative text-sm font-medium text-ink/70 hover:text-terracotta transition-colors after:absolute after:left-0 after:-bottom-1 after:h-0.5 after:w-0 after:bg-terracotta after:transition-all hover:after:w-full"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <motion.button
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.96 }}
              data-testid="nav-commission-btn"
              onClick={() => onNavigate("#order")}
              className="hidden sm:inline-flex items-center rounded-full bg-terracotta text-white text-sm font-semibold px-5 py-2.5 shadow-lg shadow-terracotta/25 hover:bg-terracotta/90 transition-colors"
            >
              Commission yours
            </motion.button>
            <button
              data-testid="nav-mobile-toggle"
              className="md:hidden p-2 rounded-full border border-ink/10 bg-white"
              onClick={() => setOpen(!open)}
              aria-label="Toggle menu"
            >
              {open ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>
        </div>

        {open && (
          <motion.nav
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, ease: EASE }}
            className="md:hidden border-t border-terracotta/10 bg-cream/95 backdrop-blur-md px-4 py-4 flex flex-col gap-1"
            data-testid="nav-mobile-menu"
          >
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(" ", "-")}`}
                onClick={(e) => go(e, l.href)}
                className="rounded-xl px-4 py-3 font-serif text-xl hover:bg-peach transition-colors"
              >
                {l.label}
              </a>
            ))}
            <button
              data-testid="nav-mobile-commission-btn"
              onClick={() => {
                setOpen(false);
                onNavigate("#order");
              }}
              className="mt-2 rounded-full bg-terracotta text-white font-semibold px-5 py-3"
            >
              Commission yours
            </button>
          </motion.nav>
        )}
      </div>
    </header>
  );
}
